<template lang="html">
  <v-app class="large-screen__body white">
    <v-btn icon class="browse__close-icon" :to="{name: 'Tasks'}">
      <v-icon>close</v-icon>
    </v-btn>
    <div class="div-container body">
      <div class="title--txt">
        What kind of community projects are you interested in?
      </div>

      <!-- toggle buttons -->
      <div class="mt-40">
        <v-container fluid class="pa-0">
          <v-btn-toggle mandatory v-model="browseType">
            <v-btn icon value="0" title="Things that can be performed anywhere by anyone.">
              All
            </v-btn>
            <v-btn icon value="1" title="Things that can be performed if you're within the location radius">
              Local
            </v-btn>
            <v-btn icon value="2" title="Things that can be performed anywhere by anyone.">
              Virtual
            </v-btn>
          </v-btn-toggle>
        </v-container>
      </div>

      <!-- description -->
      <div class="mt-40 location__description">
        <p>
          Virtual projects require your participation online, using digital tools to design,
          build and collaborate.
        </p>
        <p>
          Local projects are about the outer world: meeting people and performing physical tasks.
        </p>
      </div>
    </div>

    <div class="action-button">
      <v-btn @click="submitLocation" large class="fixed-primary-button white--text" :to="{path: '/skills'}">
        Proceed
      </v-btn>
    </div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      browseType: 0,
    };
  },
  methods: {
    submitLocation() {
      this.$store.dispatch('browseTasks/browseTaskEdit', { browse_id: this.browseId, browse_type: this.browseType });
    },
  },
  computed: {
    browseId() {
      return this.$store.getters['browseTasks/browseId'];
    },
  },
  mounted() {
    this.$store.dispatch('browseTasks/resetBrowseState');
    this.$store.dispatch('browseTasks/initializeBrowseTasks');
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
  .location__description {
    font-family: MuseoSans-500;
    font-size: 18px;
    text-align: left;
    line-height: 24px;
    padding-left: 10px;
  }

  .mt-40{
    margin-top: 40px;
  }

  .proceed-button {
    border-radius: 24px;
    background: $primary;
    font-family: MuseoSans-900;
    font-size: 16px;
    padding-left: 14px;
    padding-right: 14px;
    color: white;
    position: relative;
  }

  .button-container {
    position: fixed;
    bottom: 14px;
    cursor: not-allowed;
    text-align: center;
  }

  .large-screen__body {
    height: 100%;
  }

  .body {
    padding-top: 40px;
    padding-left: 15px;
    padding-right: 15px;
    background: white;
  }

  .div-container {
    position: relative;
    background: white;
    height: 100%;
    text-align: center;
    max-width: 600px;
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
  }

  .title--txt {
    font-size: 24px;
    padding-right: 16px;
    padding-left: 16px;
    font-family: MuseoSansRounded-1000;
    text-transform: uppercase;
  }

  .action-button {
    min-width: 130px;
    max-width: 130px;
    position: fixed;
    bottom: 5px;
    left: calc(50% - 65px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    margin-bottom: 20px;
  }

  @media only screen and (min-width:1600px) {
    .action-button {
      left: calc(50vw + 100px);
    }
  }

  .fixed-primary-button {
    background: $primary;
    font-family: MuseoSans-900;
    text-align: center;
    border-radius: 24px;
    padding: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BrowseLocation.vue